import React from "react";
import SuiBox from "components/SuiBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Grid from "@mui/material/Grid";
import MiniStatisticsCard from "examples/Cards/StatisticsCards/MiniStatisticsCard";
import { REPORT_TABS } from "./reports.constants";
import { useLocation, useNavigate, Outlet } from "react-router-dom";
import usePermissions from "utils/usePermissions";

function Reports() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { can } = usePermissions();

  const isReportsIndex = pathname === "/reports" || pathname === "/reports/";

  return (
    <>
      <DashboardLayout>
        <DashboardNavbar />
        <SuiBox py={3}>
          {isReportsIndex ? (
            <SuiBox mb={3}>
              <Grid container spacing={3}>
                {REPORT_TABS.filter((tab) => can(tab.permission)).map((tab, index) => (
                  <Grid key={index} item xs={12} sm={6} xl={4}>
                    <div
                      onClick={() => navigate(tab.path)}
                      className="cursor-pointer user-select-none dashboard-cards"
                    >
                      <MiniStatisticsCard
                        title={{ text: tab.text }}
                        count=""
                        icon={{
                          color: tab.iconColor,
                          component: tab.iconComponent,
                        }}
                      />
                    </div>
                  </Grid>
                ))}
              </Grid>
            </SuiBox>
          ) : (
            <Outlet />
          )}
        </SuiBox>
        <Footer />
      </DashboardLayout>
    </>
  );
}

export default Reports;
